import React from "react"
import { Badge } from "react-bootstrap"
import { useTranslation } from "../utils/language"

const CourseLink = ({ url, show, image, soon, title, description, place, subtitle }) => {
  const { t } = useTranslation()
  const Tag = show && url ? "a" : "div"
  const linkProps = show && url
    ? { href: url, target: "_blank", rel: "noopener noreferrer" }
    : {}

  return (
    <Tag className="course-list-item" {...linkProps}>
      <div className="course-list-logo">
        {image && <img src={image} alt={title} />}
      </div>
      <div className="course-list-body">
        <div className="d-flex align-items-center mb-1">
          <h5 className="course-list-title mb-0 mr-2">{title}</h5>
          <Badge className={soon ? "badge-upcoming" : "badge-available"}>
            {soon ? t("common.soon") : t("common.available")}
          </Badge>
        </div>
        <p className="course-list-description text-left">{description}</p>
        <small className="card-meta-place">{place} · {subtitle}</small>
      </div>
    </Tag>
  )
}

export default CourseLink
